<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('bi.sidebar.shortTitle')"
      :logo="$store.getters.systemLogoSidebar"
      :titleImg="$store.getters.systemTitleImage"
      :title="$store.getters.systemTile"
    >
      <template slot="links">
        <sidebar-item
          v-for="view in biViews"
          :key="view.id"
          :link="{
            name: view.sidebarTitle,
            icon: 'tim-icons icon-chart-pie-36',
            path: '/bi/' + view.id,
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isMasterAdmin"
          :link="{
            name: $t('system.module.sidebar'),
            path: '/bi/module/all',
            icon: 'tim-icons icon-components',
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar module="BI"></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "@/pages/Layout/DashboardNavbar.vue";
import BiNavbar from "./BiNavbar.vue";
import ContentFooter from "../../../pages/Layout/ContentFooter.vue";
import SidebarFixedToggleButton from "../../../pages/Layout/SidebarFixedToggleButton.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    BiNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
  },
  data() {
    return {
      sidebarBackground: "primary", //vue|blue|orange|green|red|primary
      biViews: [],
      isMasterAdmin: false,
    };
  },
  created() {
    this.$apiScheduler
      .get("/powerbiview/getCurrentUserViews/")
      .then((response) => {
        this.biViews = response.data;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Load data error";
            } else {
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
          window.scrollTo(0, 0);
        }
      });
    this.getUserMaster();
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-off"); // docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then((response) => {
          this.isMasterAdmin = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
  },
  mounted() {
    this.initScrollbar();
    if (this.$refs.sidebarItemForms) {
      if (this.$refs.sidebarItemForms.collapsed) {
        this.$refs.sidebarItemForms.collapseMenu();
      }
    }
  },
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.ps {
  height: 100%;
}
</style>
